import { FC } from 'react';

import BottleCapacityListing from 'components/main/BottleCapacity';

const BottleCapacity: FC = () => <BottleCapacityListing />;

export default BottleCapacity;
